import { downloadFile, IFileReturn } from "../downloadFile";

/**
 * Download annotations as a CSV file.
 *
 * @param url - URL to download the CSV from
 * @param fileName - Filename to save as
 * @returns IAxiosReturn from the download operation
 */
export const downloadAnnotationsCSV = async (
  url: string,
  fileName: string,
): Promise<IFileReturn> => {
  const response = await downloadFile({
    url,
    fileName,
    fileType: "text/csv",
    blob: true,
    successMessage: "File successfully downloaded",
    errorMessage: "An error has occurred downloading the file",
    controller: new AbortController(),
  });
  return response;
};
